var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPLogoVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H150V150H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323237",
    d: "M86.14 60c-7.349 0-12.52 3.944-12.563 9.592-.047 4.177 3.69 6.508 6.507 7.896 2.898 1.421 3.87 2.335 3.859 3.606-.02 1.947-2.311 2.806-4.451 2.84-3.737.058-5.905-1.021-7.634-1.832l-1.347 6.356c1.737.805 4.943 1.507 8.267 1.542 7.81 0 12.919-3.895 12.943-9.927.032-7.659-10.488-8.08-10.416-11.502.023-1.04 1.005-2.148 3.154-2.43 1.065-.141 4-.249 7.329 1.298l1.305-6.153C91.305 60.631 89.003 60 86.14 60zm19.512.53c-1.427 0-2.63.838-3.163 2.129L91.333 89.546h7.806l1.55-4.334h9.538l.898 4.334H118l-6.002-29.016h-6.346zm1.09 7.84l2.252 10.895h-6.165l3.914-10.895zm-42.621-7.84l-6.15 29.016h7.434l6.147-29.016h-7.431zm-11 0l-7.737 19.749-3.13-16.79c-.367-1.875-1.816-2.96-3.428-2.96h-12.65l-.176.844c2.596.57 5.547 1.489 7.334 2.467 1.094.6 1.406 1.123 1.766 2.55l5.928 23.156h7.858L60.93 60.53h-7.81z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPLogoVisa);
export default __webpack_public_path__ + "static/media/p-logo-visa.c7e5599ae333a30277a06ad084924322.svg";
export { ForwardRef as ReactComponent };